import { faArrowLeft, faArrowRight, faCar, faCreditCard, faFile, faFileArchive, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'
import Wizard from '../../../@core/components/wizard'
import { editCollectionRegister, handleChangeController, initNormalForm } from '../../../redux/actions/form'
import { StatusContext } from '../../../utility/context/StatusContext'
import { serverRequest } from '../../../utility/helpers/Axios/serverRequest'
import { FormDocumention2 } from '../../../views/addons/FormDocumention2'
import { FormPayment } from '../../../views/addons/FormPayment'
import { WizardInterpreter } from '../contactForm/ContactForm'
import './styles/wizard-form.scss'
import { CToast } from '../../../views/addons/ToastMessage'

const customer = [
    {/*  */
        type: 'card',
        collection: ['buyer'],
        title: 'Datos del cliente',
        card: [
            {
                col: [12],
                name: 'email',
                label: 'Correo electronico',
                placeholder: 'email@ejemplo.com'
            }
        ]
    }
]

const vehicle = [
    {/*  */
        type: 'card',
        collection: ['vehicle'],
        title: 'Datos del vehículo',
        card: [
            {
                col: [12],
                name: 'plate',
                label: 'Matrícula'
            }
        ]
    }

]

export const EnviromentalTag = () => {
    const [stepper, setStepper] = useState(null)
    const { form, select } = useSelector(state => state)
    const ref = useRef(null)
    const dispatch = useDispatch()
    const [activeIndex, setActiveIndex] = useState(0)

    useEffect(() => {
        dispatch(initNormalForm({
            buyer: { status: true },
            itp: {},
            saleProductTypes: ['EnviromentalTag'],
            documents: [],
            files: [],
            addTraficReport: false,
            addEnvironmentalBadge: false,
            total: 0
        }))
    }, [])

    const nextStep = () => { setActiveIndex(activeIndex + 1) }
    const prevStep = () => { setActiveIndex(activeIndex - 1) }

    const submitFiles = async (files = [], fileEndPoint, id) => {
        if (files.length !== 0) {
            for (const file of files) {
                const formData = new FormData()
                formData.append('file', file)
                formData.append('dest', 'sale')
                await serverRequest(fileEndPoint, id, formData, 'FILEUPLOAD')
            }
        }
    }
    const finishOwnerShip = async () => {
        const { saleProductTypes, addTraficReport, addEnvironmentalBadge, documents } = form
        const files = []
        const newDocuments = []

        if (addTraficReport) saleProductTypes.push('DGTReport')
        if (addEnvironmentalBadge) saleProductTypes.push('EnviromentalTag')

        for (const key in documents) {
            if (Object.hasOwnProperty.call(documents, key)) {
                const document = documents[key];
                files.push(document.file)
                delete document.file
                newDocuments.push(document)
            }
        }

        const sale = await serverRequest('sale', null, { ...form, documents: newDocuments }, 'POST')
        const total = sale.saleProducts.reduce((acc, prod) => acc + prod.price, 0)
        dispatch(handleChangeController('total', total))
        await submitFiles(files, 'saleFile', sale.id)
    }

    return (
        <div className='w-100'>
            <form className='w-100'>
                <StatusContext.Provider value={[activeIndex, setActiveIndex]}>
                    <Wizard
                        type='modern-horizontal'
                        ref={ref}
                        steps={[
                            {
                                id: 'customer-wizard',
                                title: 'Cliente',
                                subtitle: 'Datos del cliente',
                                icon: <FontAwesomeIcon icon={faUser} />,
                                content: <>
                                    <WizardInterpreter blocks={customer} />
                                    <div style={{ textAlign: 'right' }}>
                                        <Button onClick={() => {
                                            if (form.buyer.email === '' || form.buyer.email === undefined || form.buyer.email === null) {
                                                CToast({ title: 'Completa los campos', message: '- Correo' })
                                            } else {
                                                nextStep()
                                            }
                                        }} className='shown.bs-stepper' color='primary'>Siguiente <FontAwesomeIcon style={{ marginLeft: '3px' }} icon={faArrowRight} size={'1x'} /></Button>
                                    </div>
                                </>
                            },
                            {
                                id: 'vehicle-wizard',
                                title: 'Vehículo',
                                subtitle: 'Datos del vehículo',
                                icon: <FontAwesomeIcon icon={faCar} />,
                                content: <>
                                    <WizardInterpreter blocks={vehicle} />
                                    <div className='row'>
                                        <div className='col-6' style={{ textAlign: 'left' }}>
                                            <Button onClick={prevStep} color='primary'>Atras <FontAwesomeIcon style={{ marginLeft: '3px' }} icon={faArrowLeft} size={'1x'} /></Button>
                                        </div>
                                        <div className='col-6' style={{ textAlign: 'right' }}>
                                            <Button onClick={nextStep} color='primary'>Siguiente <FontAwesomeIcon style={{ marginLeft: '3px' }} icon={faArrowRight} size={'1x'} /></Button>
                                        </div>
                                    </div>
                                </>
                            },
                            {
                                id: 'docs-wizard',
                                title: 'Documentos',
                                subtitle: 'Documentacion',
                                icon: <FontAwesomeIcon icon={faFile} />,
                                content: <FormDocumention2 finishOwnerShip={finishOwnerShip} />,
                            },
                            {
                                id: 'payment-wizard',
                                title: 'Pago',
                                subtitle: 'Terminal',
                                icon: <FontAwesomeIcon icon={faCreditCard} />,
                                content: <FormPayment />,

                            }
                        ]}
                        options={{
                            linear: true
                        }}
                        instance={el => setStepper(el)}
                    />
                </StatusContext.Provider>
            </form>
        </div>
    )
}
